export class NotificacionSaldo {
  id: string;
  mensaje: string;
  destinatarios: string;
}
